import React from 'react';
import { Link } from 'react-router-dom'
import BlogSidebar from '../BlogSidebar/BlogSidebar'
import VideoModal from '../ModalVideo/VideoModal'
import blogs from '../../api/blogs'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const BlogList = (props) => {
    return (
        <section className="wpo-blog-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className={`col col-lg-8 col-12 ${props.blRight}`}>
                        <div className="wpo-blog-content">
                            {blogs.slice(0, 3).map((blog, bitem) => (
                                <div className={`post  ${blog.blClass}`} key={bitem}>
                                    <div className="entry-media video-holder">
                                        <img src={blog.PageImg} alt="" />
                                        <VideoModal />
                                    </div>
                                    <div className="entry-meta">
                                        <ul>
                                            <li>
                                                <i className="fi flaticon-user"></i> Par{' '}
                                                <Link onClick={ClickHandler} to={`#${blog.slug}`}>{blog.author}</Link>
                                            </li>
                                            <li>
                                                <i className="fi flaticon-comment-white-oval-bubble"></i> Commentaires {blog.comment}
                                            </li>
                                            <li>
                                                <i className="fi flaticon-calendar"></i> {blog.create_at}
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="entry-details">
                                        <h3>
                                            <Link onClick={ClickHandler} to={`#${blog.slug}`}>{blog.title2}</Link>
                                        </h3>
                                        <p>
                                            Le droit est un excellent choix de carrière si vous souhaitez développer un large éventail de compétences allant de la pensée critique et la planification stratégique à la communication. Si vous aimez relever des défis.
                                        </p>
                                        <Link onClick={ClickHandler} to={`#${blog.slug}`} className="read-more">
                                            LIRE LA SUITE...
                                        </Link>
                                    </div>
                                </div>
                            ))}
                            <div className="pagination-wrapper pagination-wrapper-left">
                                <ul className="pg-pagination">
                                    <li>
                                        <Link to="/blog-left-sidebar" aria-label="Précédent">
                                            <i className="fi ti-angle-left"></i>
                                        </Link>
                                    </li>
                                    <li className="active"><Link to="/blog-left-sidebar">1</Link></li>
                                    <li><Link to="/blog-left-sidebar">2</Link></li>
                                    <li><Link to="/blog-left-sidebar">3</Link></li>
                                    <li>
                                        <Link to="/blog-left-sidebar" aria-label="Suivant">
                                            <i className="fi ti-angle-right"></i>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <BlogSidebar blLeft={props.blLeft} />
                </div>
            </div>
        </section>
    )
}

export default BlogList;
